import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import BuildIcon from "@material-ui/icons/Build";
import SendIcon from '@mui/icons-material/Send';
import { Link } from "react-router-dom";

import Style from "../../../styles/js/Styles.js";

import service from "../../../plas/services/notices/service";

export default function Menu( { open, onExpand } ) {

  const style = Style();

  const [expanded, setExpanded] = React.useState(false);

  React.useEffect(() => {
    if (!open) {
      setExpanded(false);
    }
  }, [open]);

  const onClick = () => {
    if (!expanded) {
      onExpand();
    }
    setExpanded(!expanded);
  }
  
  
  return (
    <div>
     { (service.canAdmin()) ? (
        <div>
          <ListItem button onClick={onClick}>
            <ListItemIcon>
              <NewspaperIcon />
            </ListItemIcon>
            <ListItemText className={style.menuTextItem} primary="Noticias" />
            { expanded && open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={expanded && open} timeout="auto" unmountOnExit style={{paddingLeft:"24px"}}>
            <List component="div">
              <ListItem button component={Link} to={"/notices/history"}>
                <ListItemIcon>
                  <SendIcon />
                </ListItemIcon>
                <ListItemText className={style.menuTextItem}  primary="Enviar noticias" />
              </ListItem>
              <ListItem button component={Link} to={"/notices/categories"}>
                <ListItemIcon>
                  <BuildIcon />
                </ListItemIcon>
                <ListItemText className={style.menuTextItem}  primary="Categorias" />
              </ListItem>
            </List>
          </Collapse>
        </div>) : (
         <ListItem button component={Link} to={"/notices/history"}>
            <ListItemIcon>
              <NewspaperIcon />
            </ListItemIcon>
            <ListItemText className={style.menuTextItem}  primary="Noticias" />
          </ListItem>
        ) 
     }
    </div>
    
  );
}
